import { render } from "./SecondMenu.vue?vue&type=template&id=021b9e1e&scoped=true"
import script from "./SecondMenu.vue?vue&type=script&lang=js"
export * from "./SecondMenu.vue?vue&type=script&lang=js"

import "./SecondMenu.vue?vue&type=style&index=0&id=021b9e1e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-021b9e1e"]])

export default __exports__